import React from 'react';
import Link from 'next/link';
import { useSettingsRoutes } from 'src/hooks/settings';
import { PageHeader } from '../components';
import { Typography } from 'src/components';

const Admin = () => {
  const { adminRoutes: adminSections } = useSettingsRoutes();

  return (
    <div className="flex flex-col gap-6 p-6 bg-white">
      <PageHeader className="bg-sky-50">
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            <h1 className="text-xl font-semibold text-neutral-700">
              Admin Dashboard
            </h1>
            <Typography className="text-sm text-neutral">
              Manage system administration tasks and configurations
            </Typography>
          </div>
        </div>
      </PageHeader>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {adminSections.map((section) => (
          <Link
            key={section.id}
            href={section.path}
            scroll={true}
            className="block p-6 bg-white rounded-lg border border-gray-200 hover:border-sky-300 hover:shadow-md transition-all duration-200"
          >
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              {section.label}
            </h3>
            <p className="text-gray-600">{section.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Admin;
